import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

import team1 from '../assets/img/team-1.png';
import team2 from '../assets/img/team-2.png';
import team3 from '../assets/img/team-3.png';
import team4 from '../assets/img/team-4.png';
import team5 from '../assets/img/team-5.png';
import { useState } from 'react';
import { useEffect } from 'react';
import ourTeamServices from '../../services/ourTeam.services';

const OurTeam = () => {
    const [ourTeam, setOurTeam] = useState([])
    const ourTeamData = [
        {
            _id: 1,
            imgUrl: team1,
            description: "Jhon Doe is the owner and CEO of Testigo Mobile X-Ray. He began his career at XXXXX Hospital, and in 1997, was hired as Director of Imaging Services at Southwestern Medical Center. In 2001, he began providing mobile X-rays out of his garage with one van and a 24/7 schedule 365 days/year. Today, Testigo is the largest provider of mobile x-ray and ultrasound services, caring for patients throughout Pan India.",
            name: "Dr. Bruce Banner",
            designation: "CEO & Founder Testrigo"

        },
        {
            _id: 2,
            imgUrl: team2,
            description: "Jhon Doe is the owner and CEO of Testigo Mobile X-Ray. He began his career at XXXXX Hospital, and in 1997, was hired as Director of Imaging Services at Southwestern Medical Center. In 2001, he began providing mobile X-rays out of his garage with one van and a 24/7 schedule 365 days/year. Today, Testigo is the largest provider of mobile x-ray and ultrasound services, caring for patients throughout Pan India.",
            name: "Dr. Anna Walker",
            designation: "Psychiatrist"

        },
        {
            _id: 3,
            imgUrl: team3,
            description: "Jhon Doe is the owner and CEO of Testigo Mobile X-Ray. He began his career at XXXXX Hospital, and in 1997, was hired as Director of Imaging Services at Southwestern Medical Center. In 2001, he began providing mobile X-rays out of his garage with one van and a 24/7 schedule 365 days/year. Today, Testigo is the largest provider of mobile x-ray and ultrasound services, caring for patients throughout Pan India.",
            name: "Dr. Fedric Gonzalis",
            designation: "Cardiologist, CEO &amp; Founder Testrigo"

        },
        {
            _id: 4,
            imgUrl: team4,
            description: "Jhon Doe is the owner and CEO of Testigo Mobile X-Ray. He began his career at XXXXX Hospital, and in 1997, was hired as Director of Imaging Services at Southwestern Medical Center. In 2001, he began providing mobile X-rays out of his garage with one van and a 24/7 schedule 365 days/year. Today, Testigo is the largest provider of mobile x-ray and ultrasound services, caring for patients throughout Pan India.",
            name: "Jhon Doe",
            designation: "CEO &amp; Founder Testrigo"

        },
        {
            _id: 5,
            imgUrl: team5,
            description: "Jhon Doe is the owner and CEO of Testigo Mobile X-Ray. He began his career at XXXXX Hospital, and in 1997, was hired as Director of Imaging Services at Southwestern Medical Center. In 2001, he began providing mobile X-rays out of his garage with one van and a 24/7 schedule 365 days/year. Today, Testigo is the largest provider of mobile x-ray and ultrasound services, caring for patients throughout Pan India.",
            name: "Dr. Aaron Musk",
            designation: "CEO &amp; Founder Testrigo"

        }
    ];
    function createMarkup(item) {
        return {__html: item};
      }
    useEffect(()=>{
        const team = async()=>{
            const result = await ourTeamServices.listApi()
            const filterResult = result.data.data.filter(item => item.status === 1);
            if(filterResult){
                if(filterResult.length>0){
                    setOurTeam(filterResult)
                }else{
                    setOurTeam(ourTeamData)
                }
            }           
        }
        team()
    },[])
    return (
        <section className="team-sec">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="team-header text-center">
                            <h6 className="small-heading" data-aos="fade-up">Our Team</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">Meet Our Expertise &amp; Team</h3>
                        </div>
                        <div className="team-body" data-aos="fade-up">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={10}
                                pagination={{
                                    clickable: true,
                                }}
                                loop={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                centeredSlides={true}
                                breakpoints={{
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 20,
                                    },
                                    768: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                    1024: {
                                        slidesPerView: 5,
                                        spaceBetween: 20,
                                    },
                                }}
                                modules={[Pagination, Autoplay]}
                                className="our-team"
                            >
                                {
                                    ourTeam.map((item,index)=>{
                                     
                                        return(
                                            <SwiperSlide key={item._id}>
                                                <div className="team-box" key={`t${item._id}`}>
                                                    <img src={item.imgUrl} alt="" key={`img${item._id}`} />
                                                    {/* <p>{item.description}</p> */}
                                                    <div dangerouslySetInnerHTML={createMarkup(item.description)} />
                                                    <h6>{item.name}</h6>
                                                    <span>{item.designation}</span>
                                                </div>
                                            </SwiperSlide>            
                                         )
                                     
                                    })
                                }  
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurTeam;